export default {
  default: {
    paragraph: 'There is no activity for this Project.',
    title: 'No Activity',
  },
}
